import React from 'react';
import WhereAmIContent from '../components/WhereAmIContent';

const WhereAmI = () => {
  return <WhereAmIContent/>;
};

export default WhereAmI;
